module.exports = __webpack_public_path__ + "389f42ab59cbed442d6855073f121597.png";


//////////////////
// WEBPACK FOOTER
// ./images/icon-minimize.png
// module id = ./images/icon-minimize.png
// module chunks = 5